export default __webpack_public_path__ + "static/27-0bf12e5f27005ab62391dae2c301d44d.webp";